module.exports = __webpack_public_path__ + "img/icp.1d23ea25.png";